module.exports = __webpack_public_path__ + "93e8da6098ca000f98edbe907e6fcbfa.png";